/* src/modules/course_approvals/cards/CourseApprovalListCard/index.js */

import React from 'react';
// import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { compose } from 'recompose';

import { withStyles } from '@material-ui/core/styles';
import { Paper, TextField } from '@material-ui/core';

import { PaperHeader, HeaderTable } from '../../../../app/components';
// import { formatDate } from '../../../../util';
import styles from './styles';
import { filter, toUpper, map, uniq } from 'lodash';
import { fetchCourseApprovalTutors, selectCourseApprovalTutor } from '../../actions';
import { getCourseApprovals, getUniversities, getOrganizations } from '../../selectors';
import { loadTexts } from '../../../../config/texts';

const TEXT_KEY = 'course_approval';

class CourseApprovalListCard extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      searchTutor: '',
      texts: loadTexts(TEXT_KEY, props.locale)
    };
    this._onRowClick = this._onRowClick.bind(this);
  }

  componentDidMount() {
    const { universities, organizations } = this.props;
    this.props.fetchCourseApprovalTutors({ tutorSearchInput: {
      _universities: universities,
      _organizations: map(organizations, "_id"),
      approved: true,
    } });
  }

  _onRowClick({ _id }) {
    this.props.selectCourseApprovalTutor(_id);
  }

  render() {
    const { classes, courseApprovals, organizations } = this.props;
    const { searchTutor, texts } = this.state;
    let orgNames = map(organizations, 'name');
    let filteredCourseApprovals = filter(courseApprovals, c => orgNames.includes(c.organization));

    const filteredData = filter(filteredCourseApprovals, c => toUpper(c.name).includes(toUpper(searchTutor)));
    const translatedData = map(filteredData, d => ({
      _id: d._id,
      [texts.fields.name]: d.name,
      [texts.fields.organization]: d.organization,
      [texts.fields.institution]: d.institution,
      [texts.fields.date]: d.date,
      [texts.fields.approved]: d['# Approved']
    }));

    return (
      <Paper className={classes.paper}>
        <PaperHeader text={texts.header}>
          <TextField
            id="search"
            label={texts.labels.search_tutor}
            type="search"
            className={classes.textField}
            margin="normal"
            onChange={e => this.setState({ searchTutor: e.target.value })}
          />
        </PaperHeader>
        <HeaderTable data={translatedData} hover onRowClick={this._onRowClick} colored />
      </Paper>
    );
  }
}

export const mapStateToProps = state => ({
  universities: getUniversities(state),
  organizations: getOrganizations(state),
  courseApprovals: getCourseApprovals(state),
  locale: state.appState.locale,
});

const mapDispatchToProps = dispatch => ({
  fetchCourseApprovalTutors: params => dispatch(fetchCourseApprovalTutors(params)()),
  selectCourseApprovalTutor: params => dispatch(selectCourseApprovalTutor(params)),
});

export default compose(
  withStyles(styles, { name: 'CourseApprovalListCard' }),
  connect(mapStateToProps, mapDispatchToProps)
)(CourseApprovalListCard);



// WEBPACK FOOTER //
// ./src/modules/course_approvals/cards/CourseApprovalListCard/index.js